import * as dates from '@simplybenefits/sb-dates';
import { parse } from 'date-fns';
import * as localizationMaps from '../../../localization/maps.js';

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const getParsedDependentData = ({
  firstname,
  lastname,
  gender,
  relationship,
  birthdate,
  separateCoverage,
  employer,
  insuranceCarrier,
  cert,
  email,
  cohabDate,
  dateOfMarriage,
  primaryBenefits,
  hasProvincialHealthCoverage
}) => ({
  firstname,
  lastname,
  gender: localizationMaps.toEnglish('genders', gender),
  relationship: localizationMaps.toEnglish('relationships', relationship),
  birthdate: dates.getStartOfDay(parse(birthdate, 'yyyy/MM/dd', new Date()).getTime() / 1000),
  spouseCoverage: relationship !== 'Child' ? separateCoverage : null,
  employer: employer || null,
  insuranceCarrier: insuranceCarrier || null,
  dependentCertNumber: cert || null,
  email: email || null,
  hasProvincialHealthCoverage: hasProvincialHealthCoverage || false,
  cohabDate: cohabDate ? dates.getStartOfDay(parse(cohabDate, 'yyyy/MM/dd', new Date()).getTime() / 1000) : null,
  dateOfMarriage: dateOfMarriage ? dates.getStartOfDay(parse(dateOfMarriage, 'yyyy/MM/dd', new Date()).getTime() / 1000) : null,
  primaryBenefits: relationship !== 'Child' && separateCoverage ? primaryBenefits.map(benefit => localizationMaps.toEnglish('primaryBenefits', benefit)) : null
});
export default getParsedDependentData;